export default __webpack_public_path__ + "static/media/ts.8e7c2f3c.png";